import { z } from 'zod';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { SaleType } from 'modules/desking';

export const contactsStepSchema = z.object({
  ownerPgIds: z.array(z.string()),
  accountContactIds: z.array(z.string()),
});

// Aggregate-only placeholder until the Equipment step's real fields are defined
export const equipmentStepSchema = z.object({
  selectedId: z.string().nullable(),
});

// Aggregate-only placeholder until the Pricing step's real fields are defined
export const pricingStepSchema = z.object({
  lineItems: z.array(z.record(z.string(), z.unknown())),
  customerDeposit: z.object({
    type: z.nativeEnum(QuoteDepositType),
    value: z.number(),
    notes: z.string(),
  }),
});

export const financeMenuStepSchema = z.object({
  isEnabled: z.boolean(),
  saleType: z.nativeEnum(SaleType),
});

export const reviewSendStepSchema = z.object({});

export const dealBuilderFormSchema = z.object({
  contacts: contactsStepSchema,
  equipment: equipmentStepSchema,
  pricing: pricingStepSchema,
  financeMenu: financeMenuStepSchema,
  reviewSend: reviewSendStepSchema,
});
